import {
  ICustomizableContent,
  IGetAppCustomizableContent,
  ILoyaltyCustomizableContent
} from '@rbi-ctg/menu';
import { QUERY_TYPE } from 'remote/constants';
import appDataQuery from 'remote/queries/app-data';
import appDataDownloadQuery from 'remote/queries/app-data-download-section';
import appDataImagesQuery from 'remote/queries/app-data-images';
import { GetAllLoyaltyContentQuery } from 'remote/queries/fragments/loyalty-content';

import { CustomizableContentError } from '../exceptions';

export const getCustomizableContent = () => {
  return {
    queryType: QUERY_TYPE.SanityGraphqlQuery,
    maxRetries: 3,
    query: appDataQuery,
    then: (result: { allAppData: [ICustomizableContent] }) => result.allAppData[0],
    catch: (error: Error) => {
      // TODO: Design an error order state
      throw new CustomizableContentError('An error occurred loading customizable content', error);
    }
  };
};

export const getCustomizableImageContent = () => {
  return {
    queryType: QUERY_TYPE.SanityGraphqlQuery,
    maxRetries: 3,
    query: appDataImagesQuery,
    then: (result: { allAppData: [ICustomizableContent] }) => result.allAppData[0],
    catch: (error: Error) => {
      throw new CustomizableContentError(
        'An error occurred loading customizable image content',
        error
      );
    }
  };
};

export const getLoyaltyCustomizableContent = () => {
  return {
    queryType: QUERY_TYPE.SanityGraphqlQuery,
    maxRetries: 3,
    query: GetAllLoyaltyContentQuery,
    then: (result: { allLoyaltyContents: [ILoyaltyCustomizableContent] }) =>
      result.allLoyaltyContents[0],
    catch: (error: Error) => {
      throw new CustomizableContentError(
        'An error occurred loading customizable loyalty content',
        error
      );
    }
  };
};

export const getAppDownloadCustomizableContent = () => {
  return {
    queryType: QUERY_TYPE.SanityGraphqlQuery,
    maxRetries: 3,
    query: appDataDownloadQuery,
    then: (result: { allAppData: [IGetAppCustomizableContent] }) => result.allAppData[0],
    catch: (error: Error) => {
      throw new CustomizableContentError(
        'An error occurred loading customizable download section content',
        error
      );
    }
  };
};
